export function setReparaciones(state, reparaciones) {
    state.reparaciones = reparaciones;
}

export function setReparacionSelec(state, reparacion) {
    state.reparacionSelec = reparacion;
}

export function actListReparaciones(state, reparacion) {
    if (reparacion !== null) {
        const index = state.reparaciones.findIndex(r => r.id === reparacion.id)
        if (index != -1) {
            state.reparaciones[index].fecha_inicial = reparacion.fecha_inicial;  
            state.reparaciones[index].fecha_final = reparacion.fecha_final;  
            state.reparaciones[index].bici = reparacion.bici;  
            state.reparaciones[index].observaciones = reparacion.observaciones;  
        }
    }
  
}

export function actDeleteListReparaciones(state, id) {
    if (id != null) {
        const index = state.reparaciones.findIndex(r => r.id === id)
        if (index != -1) {
            state.reparaciones.splice(index, 1)
        }
    }
}